import { render } from "./Participant.vue?vue&type=template&id=0041e933&scoped=true"
import script from "./Participant.vue?vue&type=script&lang=ts"
export * from "./Participant.vue?vue&type=script&lang=ts"

import "./Participant.vue?vue&type=style&index=0&id=0041e933&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0041e933"

export default script